{
  //footer newsletter 
  const initFooterNewsletter = () => {
    const form = document.getElementById('footer-newsletter-form');
    const responseEl = document.getElementById('footer-form-response');
    
    if (!form) return;
    
    // Your Klaviyo public API key/company ID
    const KLAVIYO_PUBLIC_KEY = "pUeXL2"; // Replace with your actual public key
    
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      // Get the email and check consent
      const email = form.querySelector('input[name="email"]').value;
      const consent = form.querySelector('input[name="gdpr-consent"]').checked;
      
      // Validate consent
      if (!consent) {
        responseEl.textContent = 'Please accept the privacy policy to continue.';
        responseEl.className = 'form-response error';
        return;
      }
      
      // Clear previous messages
      responseEl.textContent = '';
      responseEl.className = 'form-response';
      
      // Add loading state
      const submitBtn = form.querySelector('button[type="submit"]');
      const originalBtnContent = submitBtn.innerHTML;
      submitBtn.disabled = true;
      // submitBtn.innerHTML = 'Loading...';
      
      // Current timestamp for consent
      // const timestamp = new Date().toISOString();
      // convert timestamp to ISO no time
      function getISOWithTimezone() {
        const date = new Date();
        const isoString = date.toISOString().split('Z')[0];
        const offset = date.getTimezoneOffset();
        const prefix = offset <= 0 ? '+' : '-';
        const hours = Math.abs(Math.floor(offset / 60)).toString().padStart(2, '0');
        const minutes = Math.abs(offset % 60).toString().padStart(2, '0');
        
        return `${isoString}${prefix}${hours}:${minutes}`;
      }

      const timestamp = getISOWithTimezone();
      
      // Build request options using Klaviyo's client API
      const options = {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          revision: '2025-07-15', // Current API version
          'content-type': 'application/vnd.api+json'
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              custom_source: "Website footer newsletter form",
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: email,
                    subscriptions: {
                      email: {
                        marketing: {
                          consent: "SUBSCRIBED"
                        }
                      }
                    }
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: "WQpis3"
                }
              }
            }
          }
        })
      };

      console.log('Klaviyo API request options:', options);

      // Add the public key to the URL
      const apiUrl = `https://a.klaviyo.com/client/subscriptions?company_id=${KLAVIYO_PUBLIC_KEY}`;
      
      // Make the request to Klaviyo
      fetch(apiUrl, options)
        .then(response => {
          // Check if status is 200 or 202 (success)
          if (response.status === 200 || response.status === 202) {
            // Success - even if response is empty
            return { success: true };
          } else {
            // Try to parse error response
            return response.json().then(data => {
              throw new Error(JSON.stringify(data));
            });
          }
        })
        .then(data => {
          // Success
          setTimeout(() => {
            form.reset();
          }, 300);
          responseEl.innerHTML = '<span>Thanks for subscribing!</span>';
          responseEl.classList.add('success');
        })
        .catch(error => {
          // Error
          responseEl.innerHTML = '<span>Something went wrong. Please try again.</span>';
          responseEl.classList.add('error');
          console.error('Error:', error);
        })
        .finally(() => {
          // Restore button state
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalBtnContent;
        });
    });
  }

  const initFooter = () => {
    const applyFooterLogic = () => {
      // Only apply on screens smaller than 768px
      if (window.innerWidth < 768) {
        const mobileFooterLists = document.querySelectorAll('.footer__menu-item--title-wrapper');

        mobileFooterLists.forEach(list => {
          // Prevent double-binding
          list.removeEventListener('click', toggleHandler);
          list.addEventListener('click', toggleHandler);
        });
      }

      //if homepage init newsletter
      if (window.location.pathname === '/' || window.location.pathname === '/index.html') {
        initFooterNewsletter();
      }
    };

    const toggleHandler = (e) => {
      const parent = e.currentTarget.parentElement;
      const expanded = parent.getAttribute('aria-expanded') === 'true';

      e.preventDefault();
      parent.setAttribute('aria-expanded', !expanded);
      parent.style.maxHeight = expanded ? '2.3rem' : parent.scrollHeight + 'px';
    };

    // Init on load
    applyFooterLogic();

    // Re-check on resize
    window.addEventListener('resize', () => {
      applyFooterLogic();
    });
  };

  initFooter();
}